import { RouteContentProductAppMap } from 'utils/routing/routeProductMaps'

// Flag that switches the High School dashboard card from the legacy content-v2
// `dashboardProgram` fetch to the curriculum service. Gated by the shared k12
// core curriculum-service integration flag. This flag also switches the HS
// course-tree fetch (see HighSchoolProgramCard/component.jsx) from the legacy
// CourseManagerGetter to the curriculum-service CurriculumCourseManagerGetter,
// so content and course trees flip together. Does NOT affect the dashboard
// shell (GetRootContent / GetContentfulResource).
export const HS_DASHBOARD_CURRICULUM_FLAG =
  'feature_LEARN-28473-learn-k12-core-curriculum-service-integration'

// The curriculum-service route (in the `educatorDashboard` content group) that
// resolves to the HS dashboardProgram page. The card is rendered without a
// route match, so the path is fixed here rather than derived from `match`.
export const HS_DASHBOARD_ROUTE_PATH = '/dashboard/grades-9-12'

// Options for CurriculumRouteContentGetter: the `learnEducatorDashboard` app
// maps to the `educatorDashboard` content group (see routeProductMaps), and the
// fixed routeResolver bypasses the product/program URL normalization.
export const HS_DASHBOARD_CURRICULUM_OPTIONS = {
  app: RouteContentProductAppMap.learnEducatorDashboard,
  routeResolver: () => HS_DASHBOARD_ROUTE_PATH,
}
